import React, { useState, useEffect } from "react";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import { Content, Main } from "../../components/Layout";
import { Row, Col } from "react-bootstrap";
import Slct from "../../components/Slct";
import Loading from "../../components/Loading";
import Pagenation from "../../components/Pagenation";
import { IntegerNumber, InputText, InputDocument, InputEmail } from "../../components/Input";
import StatusFlag from "../../components/StatusFlag";
import useFormat from "../../hooks/utils/useFormat";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import getCommercial from "../../util/getCommercial";
import TableResponsive from "../../components/TableResponsive";
import Accordion2 from "../../components/Accordion";
import ButtonLink from "../../components/Button/ButtonLink";
import { listTrainees } from "../../hooks/api/listTrainees";
import MeusDadosIco from "../../components/Svg/new/meus-dados";
import Tooltip2 from "../../components/Tooltip";

export default function Trainees() {
  const { config, setbreadcrumb, permissions } = useWrapper();
  const { formatQuery, formatPhone } = useFormat();

  const [isLoadingEssential, setisLoadingEssential] = useState(false);
  const [isLoadingTrainees, setisLoadingTrainees] = useState();
  const [isWaitingResponse, setisWaitingResponse] = useState();
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingTrainees);
  }, [isLoadingEssential, isLoadingTrainees]);

  const [trainees, settrainees] = useState();
  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);
  const applyFilter = async (__filter, __setPreset) => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingTrainees(true);
      const _filter = __filter || filter;
      if (!!__filter) setfilter(__filter);

      const { status, ...query } = _filter;
      const _status_query =
        status === "Revogado"
          ? { active: 0, approve_by_team: 1, aceite_virtual: 1 }
          : status === "Aguardando Aprovação"
            ? { active: 1, approve_by_team: 0 }
            : status === "Aguardando Aceite"
              ? { active: 1, approve_by_team: 1, aceite_virtual: 0 }
              : status === "Autorizado"
                ? { active: 1, approve_by_team: 1, aceite_virtual: 1 }
                : {};
      const _query = `?joins=null&limite=30&paginate=true&${formatQuery({
        ...query,
        ..._status_query,
      })}`;

      const _trainees = await listTrainees({
        config,
        query: _query,
      });

      settrainees(_trainees);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar os formandos.");
    } finally {
      setisLoadingTrainees(false);
    }
  };

  const [commercials, setcommercials] = useState([]);
  const [institutions, setinstitutions] = useState([]);
  const [courses, setcourses] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const _commercials = await getCommercial(null, null, "?is_class=1&joins=institution,course");
        setcommercials(
          [{ value: null, label: "-- Todas --" }].concat(
            _commercials?.map(__commercial => ({
              ...__commercial,
              trainees: [{ value: null, label: "-- Todos --" }].concat(
                __commercial.trainees?.map(__trainee => ({
                  value: __trainee.id,
                  label: __trainee.name,
                })),
              ),
            })),
          ),
        );
        const { data: _institutions } = await api.get("institutions?joins=null&paginate=false", config);
        setinstitutions(
          [{ value: null, label: "-- Todas --" }].concat(
            _institutions?.map(__institution => ({
              value: __institution.id,
              label: __institution.title || "-",
            })),
          ),
        );

        const { data: _courses } = await api.get("courses", config);
        setcourses(
          [{ value: null, label: "-- Todos --" }].concat(
            _courses.map(__course => ({
              value: __course.id,
              label: __course.title,
            })),
          ),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar a lista de Turmas e Instituições.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
  }, []);

  useEffect(() => {
    setbreadcrumb([{ label: "Formandos" }]);
  }, []);

  return (
    <Main>
      {!isLoadingEssential ? (
        <Content>
          <Row>
            <Col>
              <h2 className="mini-title">Formandos:</h2>
              <p className="small-label mb-3">
                Confira todas os formandos registradas, com informações essenciais e acesso a detalhes completos sobre
                cada um.
              </p>
            </Col>
            {permissions.trainee.create && (
              <Col sm={3} className="d-flex justify-content-end align-items-start">
                <ButtonLink color="primary" to="/trainees/new">
                  Cadastrar Formando
                </ButtonLink>
              </Col>
            )}
          </Row>
          <Accordion2 id="page-filter">
            <Accordion2.Item eventKey={`page-filter`}>
              <Accordion2.Header>
                <span>Filtro</span>
                <Accordion2.Extras>
                  <span>{trainees?.total} resultados</span>
                </Accordion2.Extras>
              </Accordion2.Header>
              <Accordion2.Body>
                <Row>
                  <Col sm={3}>
                    <span>Financeiro</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={[
                        { value: null, label: "-- Todos --" },
                        { value: 1, label: "Criado" },
                        { value: 0, label: "Sem Financeiro" },
                      ]}
                      placeholder="..."
                      value={filter?.financial_released}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          financial_released: __ev.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Acesso</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={[
                        { value: null, label: "-- Todos --" },
                        { value: "Revogado", label: "Revogado" },
                        { value: "Aguardando Aprovação", label: "Aguardando Aprovação" },
                        { value: "Aguardando Aceite", label: "Aguardando Aceite" },
                        { value: "Autorizado", label: "Autorizado" },
                      ]}
                      placeholder="..."
                      value={filter?.status}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          status: __ev.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Vínculo</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={[
                        { value: null, label: "-- Todos --" },
                        { value: 0, label: "Ativo" },
                        { value: 1, label: "Encerrado" },
                      ]}
                      placeholder="..."
                      value={filter?.cancel}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          cancel: __ev.value,
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col sm={6}>
                    <span>Turma</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={commercials}
                      placeholder="..."
                      value={filter?.commercial_id}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          commercial_id: __ev.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Ano/Período</span>
                    <div className="ano-periodo">
                      <IntegerNumber
                        disabled={!!isWaitingResponse}
                        value={filter?.year}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            year: __ev,
                          });
                        }}
                        maxlength="4"
                      />
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        options={[
                          { value: null, label: "1 e 2" },
                          { value: 1, label: "1" },
                          { value: 2, label: "2" },
                        ]}
                        placeholder="..."
                        value={filter?.["commercials.period"]}
                        onChange={e => {
                          setfilter({
                            ...filter,
                            "commercials.period": e.value,
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col sm={6}>
                    <span>Nome</span>
                    <InputText
                      disabled={!!isWaitingResponse}
                      placeholder="..."
                      value={filter?.name}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          name: __ev.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>CPF</span>
                    <InputDocument
                      disabled={!!isWaitingResponse}
                      type="cpf"
                      value={filter?.cpf || ""}
                      valueChange={__ev => {
                        setfilter({
                          ...filter,
                          cpf: __ev,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>E-Mail</span>
                    <InputEmail
                      disabled={!!isWaitingResponse}
                      value={filter?.email}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          email: __ev.target.value,
                        });
                      }}
                      placeholder="usuario@email.com"
                    />
                  </Col>
                </Row>
                {!isWaitingResponse && (
                  <Row className="mt-3">
                    <Col>
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          applyFilter();
                        }}
                      >
                        Aplicar Filtro
                      </Button>
                      <Button
                        color="grey"
                        size="sm"
                        onClick={() => {
                          applyFilter(filter_init);
                        }}
                      >
                        Limpar Filtro
                      </Button>
                    </Col>
                  </Row>
                )}
              </Accordion2.Body>
            </Accordion2.Item>
          </Accordion2>
          <Row className="mt-4">
            <Col>
              {!isLoadingTrainees ? (
                <>
                  <TableResponsive
                    emptyMsg="Nenhuma formando encontrado."
                    table={{
                      head: [
                        { data: "ID" },
                        { data: "Formando" },
                        { data: "Turma" },
                        { data: "Contato" },
                        { data: <div className="text-end">Financeiro</div> },
                        { data: <div className="text-end">Acesso</div> },
                        { data: <div className="text-end">Vínculo</div> },
                      ],
                      body:
                        trainees?.data?.map(__trainee => {
                          return {
                            link: `/trainees/edit/${__trainee.id}`,
                            disabled: !!__trainee?.cancel,
                            data: [
                              { element: __trainee.id },
                              {
                                element: (
                                  <>
                                    {__trainee.is_member ? (
                                      <span className="smaller-ico">
                                        <MeusDadosIco />
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    {__trainee.name}
                                  </>
                                ),
                              },
                              {
                                element:
                                  commercials?.find(__commercial => __commercial.value === __trainee.commercial_id)
                                    ?.label || "-",
                              },
                              {
                                element: (
                                  <>
                                    <p className="m-0">{formatPhone(__trainee?.cell)}</p>
                                    <p className="m-0">{__trainee?.email}</p>
                                  </>
                                ),
                              },
                              {
                                element: (
                                  <div className="text-end">
                                    <StatusFlag status={!__trainee?.financial_released ? "Sem Financeiro" : "Criado"} />
                                  </div>
                                ),
                              },
                              {
                                element: (
                                  <div className="text-end">
                                    <StatusFlag status={__trainee?.access || "?"} />
                                  </div>
                                ),
                              },
                              {
                                element: (
                                  <div className="text-end">
                                    <StatusFlag status={__trainee?.bond || "?"} />
                                  </div>
                                ),
                              },
                            ],
                          };
                        }) || [],
                    }}
                  />
                  <Pagenation
                    current={trainees?.page}
                    total={trainees?.lastPage}
                    pageChange={__page => {
                      applyFilter({
                        ...filter,
                        page: __page,
                      });
                    }}
                    className="mt-4"
                  />
                </>
              ) : (
                <Loading />
              )}
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
